import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IStation, IStationAssignmentCreate, IStationCreate } from '@tsin-core/models/station-management.model';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';

const STATION_URL = `${environment.apiUrl}/stations`;

@Injectable({
  providedIn: 'root',
})
export class StationManagementService {
  constructor(private http: HttpClient) {}

  createStation(station: Omit<IStationCreate, 'id'>): Observable<IStation> {
    return this.http.post<IStation>(STATION_URL, station);
  }

  createStationAssignment(station: Omit<IStationAssignmentCreate, 'id'>): Observable<IStation> {
    return this.http.patch<IStation>(`${STATION_URL}/assign-admin`, station);
  }

  updateStation(station: Omit<any, 'id'>): Observable<IStation> {
    return this.http.put<IStation>(STATION_URL, station);
  }

  getStations(): Observable<IStation[]> {
    return this.http.get<IStation[]>(STATION_URL);
  }

  deleteStation(id: string): Observable<any> {
    return this.http.delete(`${STATION_URL}/single/${id}`);
  }


}
